import type { JSX, ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SurfaceCardProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function SurfaceCard({
  children,
  className,
  contentClassName,
}: SurfaceCardProps): JSX.Element {
  return (
    <Card className={cn('shadow-sm', className)}>
      <CardContent className={cn('p-6', contentClassName)}>{children}</CardContent>
    </Card>
  );
}
